module.exports = __webpack_public_path__ + "img/logo-light.0c7381c2.png";